import React from 'react';

import { Drawer } from '@pkg/components';
import { useAuthentication } from '@pkg/hooks';

import config from '@app/config';
import { YAT_PICKER } from '@app/routes/paths';

import {
    ActionLabel,
    ActionsGroup,
    Content,
    PrimaryLink,
    SecondaryAction,
    Subtitle,
    TextLink,
    TextLinkItem,
    TextLinkList,
    Title,
} from './GuestDrawer.style';

export interface GuestDrawerProps {
    onClose: () => void;
}

const { privacyLink, termsLink } = config;

export function GuestDrawer({ onClose }: GuestDrawerProps) {
    const { authenticate } = useAuthentication();

    return (
        <Drawer backdrop onClose={onClose}>
            <Drawer.Main divided>
                <Drawer.Main.Section>
                    <TextLinkList>
                        <TextLinkItem>
                            <TextLink url={privacyLink} external>
                                Privacy Policy
                            </TextLink>
                        </TextLinkItem>

                        <TextLinkItem>
                            <TextLink url={termsLink} external>
                                Terms of Service
                            </TextLink>
                        </TextLinkItem>
                    </TextLinkList>
                </Drawer.Main.Section>

                <Drawer.Main.Section>
                    <Content>
                        <Title>Create your own Yat</Title>
                        <Subtitle>Express youself with a unique emoji URL and flex your links, NFTs and more.</Subtitle>

                        <ActionsGroup>
                            <SecondaryAction onAction={() => authenticate()}>
                                <ActionLabel>Sign up / Log in</ActionLabel>
                            </SecondaryAction>

                            <PrimaryLink url={YAT_PICKER} state={{ enableGoBack: true }}>
                                <ActionLabel>Create a Yat</ActionLabel>
                            </PrimaryLink>
                        </ActionsGroup>
                    </Content>
                </Drawer.Main.Section>
            </Drawer.Main>
        </Drawer>
    );
}
